export interface CandidateProfile {
  id: string;
  name: string;
  title: string;
  apiBase: string;
  tagline: string;
  avatar: string; // Initials-based for now
  /** Thesis the prototype proves about this candidate */
  archetype: 'exceptional' | 'ats-darling' | 'hidden-gem';
}

const IS_LOCAL = typeof window !== 'undefined' && window.location.hostname === 'localhost';

export const CANDIDATES: CandidateProfile[] = [
  {
    id: 'ted-lango',
    name: 'Ted Lango',
    title: 'Contact Center Strategist & Author',
    apiBase: 'https://living-resume-api.tedlango.workers.dev',
    tagline: 'Operator → Strategist → Innovator',
    avatar: 'TL',
    archetype: 'exceptional',
  },
  {
    id: 'sarah-chen',
    name: 'Sarah Chen',
    title: 'SVP, Contact Center Operations',
    apiBase: IS_LOCAL ? 'http://localhost:8787' : 'https://candidate-sarah-api.tedlango.workers.dev',
    tagline: '18 years in enterprise contact centers',
    avatar: 'SC',
    archetype: 'ats-darling',
  },
  {
    id: 'marcus-rivera',
    name: 'Marcus Rivera',
    title: 'VP, Business Transformation',
    apiBase: IS_LOCAL ? 'http://localhost:8788' : 'https://candidate-marcus-api.tedlango.workers.dev',
    tagline: 'Data science meets operations',
    avatar: 'MR',
    archetype: 'hidden-gem',
  },
];

export function getCandidateById(id: string): CandidateProfile | undefined {
  return CANDIDATES.find((c) => c.id === id);
}
